export default {
  login: {
    login: '登录',
    formTitle: '登录LUCKY PM管理系统',
    userNameTip: '请输入用户名',
    passwordTip: '请输入密码',
    welcome: '欢迎',
    register: '注册',
    confirePassword: '确认密码',
    passwordAgain: '请再次输入密码',
    phoneByDingTalk: '手机号码(钉钉)',
    phoneFormat: '手机号码格式错误',
    passwordInconsistent: '密码不一致',
    registerSuccess: '成功注册,请登录',
    smsCode: '验证码',
    getSmsCode: '获取验证码',
    againGetSmsCode: '{countDown}秒后重新获取',
  },
  account: {
    accountInfo: '账号信息',
    userName: '用户',
    password: '密码',
    avatar: '头像',
    language: '语言',
    active: '激活',
    mobile: '手机号码',
    DingTalkID: '钉钉ID',
    permission: '权限',
    role: '角色',
    team: '团队',
    updatePassword: '修改密码',
    passwordNoEmpty: '密码不可为空',
    loginAgain: '重置密码后需要重新登录',
    avatarUrl: '图片地址',
    preview: '预览',
    avatarUrlError: '图片地址错误',
    updateAccount: '更新用户资料',
    updateAvatar: '更新头像',
    activedLoginAgain: '激活后才可登录使用',
  },
  navbar: {
    account: '账号信息',
    refresh: '刷新',
    logout: '退出',
    menu: '菜单',
  },
  label: {
    label: '标签',
    name: '标签名',
    comment: '描述',
    color: '颜色',
    public: '公开',
    active: '激活',
    creater: '创建人',
    createLabel: '创建标签',
    editLabel: '编辑标签',
  },
  route: {
    home: '主页',
    requirement: '需求',
    requirementList: '需求列表',
    createRequirement: '创建需求',
    updateRequirement: '编辑需求',
    solution: '报价单',
    solutionList: '报价单列表',
    createSolution: '创建报价单',
    updateSolution: '编辑报价单',
    payment: '请款单',
    paymentList: '请款单列表',
    createPayment: '创建请款单',
    updatePayment: '编辑请款单',
    config: '配置',
    quotation: '报价类型',
    role: '角色',
    editRole: '编辑角色',
    project: '项目',
    team: '团队',
    user: '用户',
    permission: '权限',
    module: '模块',
    moduleList: '模块列表',
    createModule: '创建模块',
    updateModule: '编辑模块',
    createTemplate: '创建模块模板',
    updateTemplate: '编辑模板',
    todo: '任务',
    todoList: '任务列表',
    createTodo: '创建任务',
    account: '账号信息',
    issue: '议题',
    issueList: '议题列表',
    createIssue: '创建议题',
    updateIssue: '编辑议题',
    label: '标签',
    todoType: '任务类型',
    settlementUnit: '結算單位',
    report: '报表',
    reportDetail: '明细',
    reportSummary: '汇总',
    notFound: '404',
  },
  form: {
    yes: '是',
    no: '否',
    cancel: '取消',
    submit: '提交',
    required: '必填项',
    send: '发送',
    edit: '编辑',
    delete: '删除',
    pass: '通过',
    reject: '拒绝',
    create: '创建',
    approve: '采纳',
    close: '关闭',
    complete: '完成',
    search: '搜索',
    moreSearch: '更多搜索',
  },
  operation: {
    loadMore: '加载更多',
    related: '关联',
    operation: '操作',
    confirmMsg: '确认{operation}?',
    goBack: '返回',
    view: '查看',
    start: '開始',
    end: '結束',
    copy: '复制',
    agree: '同意',
    accept: '接受',
  },
  logs: {
    log: '日志',
    user: '用户',
    content: '内容',
    time: '时间',
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOther: '关闭其他',
    closeAll: '关闭全部',
  },
  comment: {
    comment: '评论',
  },
  requirement: {
    requirement: '需求',
    create: '创建需求',
    detail: '需求信息',
    loadMore: '加载更多',
    edit: '编辑',
    searchKey: '需求标题',
    name: '标题',
    remarks: '备注',
    description: '描述',
    due: '计划完成',
    label: '标签',
    creater: '创建人',
    createOn: '创建时间',
    urgency: '紧急程度',
    status: '状态',
    public: '是否公开',
    adopt: '采纳',
    delete: '删除',
    close: '关闭',
    other: '其他',
    solution: '报价单',
    module: '模块',
    createSolution: '创建',
    view: '查看',
    manDay: '價值',
    issue: '议题',
    project: '项目',
  },
  solution: {
    quotaion: '报价',
    searchKey: '报价单标题',
    createSolution: '创建报价单',
    unableCreate: '缺少参数,无法创建报价单,即将返回',
    unableEdit: '缺少参数,无法修改报价单,即将返回',
    type: '类型',
    title: '标题',
    manDay: '價值',
    creater: '创建人',
    approval: '审批',
    pass: '通过',
    reject: '拒绝',
    departmentHead: '部门负责人',
    wait: '等待',
    paymentNote: '填写请款单',
    solution: '报价单',
    status: '状态',
    label: '标签',
    share: '是否共享',
    remarks: '描述',
    totalManDay: '总價值',
    baseInfo: '基本信息',
    requirement: '需求',
    specificInfo: '具体信息',
    operation: '操作',
    addQuotation: '增加报价',
    lackOfQuotation: '缺少报价条款',
    startDate: '开始跟进日期',
    endDate: '交付成果日期',
    workDays: '工期',
    effectiveDate: '有效期',
    workDates: '需求周期',
    atLeast: '至少一项报价',
    typeNotApplicable: '報價類型不適用',
  },
  payment: {
    create: '创建请款单',
    payment: '请款单',
    searchKey: '请款单标题',
    unableCreate: '缺少参数,无法创建请款单,即将返回',
    unableEdit: '缺少参数,无法修改请款单,即将返回',
    label: '标签',
    projectReturns: '项目回报',
    returnType: '回报类型',
    superposition: '是否叠加',
    concreteContent: '具体内容',
    timeSavingCalculation: '节约时间计算',
    usageTimes: '使用次数',
    saveTime: '每次每人节省时间',
    affectedDepartments: '每次影响部门',
    actualRevenue: '实际收益人数',
    remarks: '备注',
    specificCalculation: '具体计算',
    manDayReport: '價值',
    nonWarranty: '非保修',
    warranty: '保修',
    guarantee: '保修',
    requirement: '需求情况',
    requirementNum: '需求号',
    manDaystatus: '状态',
    follower: '跟进人',
    softwareVP: '软件VP',
    requirementDue: '需求完成时间',
    requirementDesc: '需求简述',
    requirementName: '需求名称',
    project: '项目名称',
    manDay: '價值',
    warrantyPrice: '保修价',
    noWarrantyPrice: '非保修价',
    addQuotation: '添加报价单',
    quotationList: '报价单列表',
    quotation: '报价单',
    title: '标题',
    creater: '创建人',
  },
  paymentOptions: {
    nothing: '无',
    superposition: '叠加',
    increaseRevenue: '增加公司收益',
    savingManpower: '可节约人力',
    costSaving: '可节省成本',
    notSelected: '未选择',
    lessThanOrEqualToTwiceAYear: '一年少于等于2次',
    lessThanOrEqualTo5TimesAYear: '一年少于等于5次',
    lessThanOrEqualTo10TimesAYear: '一年少于等于10次',
    lessThanOrEqualTo11TimesAYear: '一年少于等于11次',
    AMonthTo1_3Times: '每月1~3次',
    AWeekTo1_3Times: '每周1~3次',
    AWeekTo4_5Times: '每周4~5次',
    ADayTo1_3Times: '每天1~3次',
    MoreThan3TimesADay: '每天3次以上',
    within1Minute: '1分钟之内',
    minute1_30: '1~30分钟',
    minute30_60: '30~60分钟',
    minute60_90: '60~90分钟',
    minute90_120: '90~120分钟',
    minute120_150: '120~150分钟',
    minute150_180: '150~180分钟',
    moreThan180minute: '180分钟以上',
    department1: '1个部门',
    departments2_3: '2~3个部门',
    departments4_6: '4~6个部门',
    departments6_8: '6~8个部门',
    MoreThan8Departments: '8个部门以上',
    person1: '1人',
    person2_5: '2~5人',
    person6_10: '6~10人',
    person11_15: '11~15人',
    person16_25: '16~25人',
    person26_35: '26~35人',
    MoreThan35Person: '35人以上',
  },
  module: {
    module: '模块',
    searchKey: '模块名',
    creater: '创建人',
    unableCreate: '缺少参数,无法创建模块,即将返回',
    unableEdit: '缺少参数,无法修改模块,即将返回',
    label: '标签',
    requirement: '需求',
    due: '计划完成',
    project: '项目',
    team: '开发组',
    manDay: '價值',
    isGuarantee: '保修',
    noGuarantee: '非保修',
    name: '模块名',
    remark: '備注',
    remarkPlaceholder: '請填寫模塊服務包所含內容簡介',
    createModule: '创建模块',
    editModule: '编辑模块',
    createTemplate: '创建模块模板',
    createTemplateTodo: '创建模板任务',
    editTemplate: '编辑模板',
    taskList: '任务列表',
    settlement: '結算',
    followUp: '跟進',
    grab: '搶單',
    settled: '已結算',
    overQuotation: '超过报价，无法結算',
    confirmTips: '可用 {paymentManDay} ，已选 {todoCount} 个todo，消耗 {todoManday} ，确认？(只能結算一次)',
    cancelTips: '任务数据必须都为 Completed 或 Closed 状态才可取消模块',
    singleCopy: '單個複製',
    batchCopy: '批量複製',
    copy: '複製',
  },
  todo: {
    createTodo: '创建任务',
    unableCreate: '缺少参数,无法创建任务',
    project: '項目',
    title: '标题',
    type: 'Todo 类型',
    module: '模块',
    owner: '跟进人',
    manDay: '價值',
    bonus: '結算状态',
    settlementUnit: '結算單位',
    totalValue: '總價值',
    totalValueMsg: '跟進人價值總和不能超過類型價值',
    ownerMsg: '至少需要一位跟进人',
    due: '计划完成',
    remarks: '備注',
    checkIn: '签入',
    checkOut: '签出',
    complete: '完成',
    termination: '终止',
    delete: '撤销',
    check: '检查',
    checked: '已检查',
    status:  '状态',
    action: '操作',
    records: '记录',
    reviewer: '审核人',
    moduleSettled: '模块已結算',
    batchCreate: '批量创建',
    change: '修改',
    transfer: '轉交',
    remarkTips: '請填寫備注信息',
    acceptorTips: '請選擇用戶',
    todoOriginalValue: '此任務原價值',
    actualAdjustment: '按實際調整為',
    transferTodos: '轉交任務給',
    forCheck: '进行检查',
    grab: '搶單',
    range: '範圍',
    comment: '備注',
    commentTips: '請填寫任務內容簡介、接收基本要求和條件等',
  },
  quotation: {
    name: '类型名称',
    project: '適用項目',
    require: '必选',
    additional: '附加',
    active: '激活',
  },
  role: {
    name: '角色名称',
    comment: '描述',
    creater: '创建人',
    permission: '权限',
    user: '用户',
    active: '激活',
    createRole: '创建角色',
    editRole: '修改角色',
    updateUser: '更新用户',
    updatePermission: '更新权限',
    unableEdit: '缺少参数,无法编辑角色,即将返回',
  },
  permission: {
    comment: '描述',
    groupName: '类别',
    name: '权限名',
    user: '用户',
    role: '角色',
    active: '激活',
    updateUser: '更新用户',
    updateRole: '更新角色',
  },
  project: {
    project: '项目',
    name: '项目名',
    description: '描述',
    createdName: '创建人',
    active: '激活',
    team: '开发组',
    manager: '管理员',
    createProject: '创建项目',
    editProject: '编辑项目',
    updateTeam: '更新开发组',
    updateManager: '更新管理员',
  },
  team: {
    name: '团队名',
    comment: '描述',
    owner: '负责人',
    createdName: '创建人',
    member: '成员',
    manager: '管理员',
    createTeam: '创建团队',
    editTeam: '编辑团队',
    updateMember: '更新成员',
    updateManager: '更新管理员',
    project: '项目',
    active: '激活',
  },
  user: {
    name: '用户名',
    permission: '个人权限',
    role: '角色',
    team: '团队',
    updateRole: '更新角色',
    updatePermission: '更新个人权限',
    updateTeam: '更新团队',
    active: '激活',
    mobile: '手机号码',
  },
  todoType: {
    project: '項目',
    type: '類型',
    creater: '創建人',
    active: '激活',
    firstCategory: '分類一',
    secondCategory: '分類二',
    thirdCategory: '分類三',
    value: '價值',
    category: '分類',
    templateDownload: '模板下載',
    format: '格式限定',
    onlyIntegers: '只填写整数',
    keepTwoDecimalPlaces: '保留两位小数',
  },
  settementUnit: {
    type: '类型',
    creater: '创建人',
    active: '激活',
  },
  issue: {
    issue: '议题',
    create: '创建议题',
    loadMore: '加载更多',
    edit: '编辑',
    searchKey: '搜索关键字',
    title: '标题',
    description: '描述',
    reminder: '提醒人',
    label: '标签',
    creater: '创建人',
    createOn: '创建时间',
    urgency: '紧急程度',
    status: '状态',
    adopt: '采纳',
    reject: '拒绝',
    close: '关闭',
    cancel: '取消',
    view: '查看',
  },
  report: {
    title: '标题',
    module: '模块',
    creator: '创建人',
    todoType: 'Todo 类型',
    owner: '跟进人',
    due: '計劃完成日期',
    status:  '状态',
    manDay: '價值',
    bonus: '結算状态',
    notData: '暂无数据',
    notExport: '无法导出',
    selectInterval: '选择日期区间',
    settlementDate: '結算日期',
    sumManDay: '合计(價值)',
    project: '項目',
    quotationCategory: '報價類型',
    settlementUnit: '結算單位',
  },
  remind: {
    checkTodo: '有需要检查的任务',
    settlementModuleByToday: '有需要结算的模块',
    settlementModuleByWithinThreeDay: '未来三天有需要结算的模块',
    haveNewTodo: '你有新任務！請前往查看。',
    isCompletedTodo: '你的任務是否已完成？請前往處理！',
    haveUnfinishedTodo: '你有任務未完成，請前往處理！',
    haveNewGrabTodo: '你有新的搶單任務發佈，請前往查看',
    grabTodoHasAccepted: '你發佈的搶單任務已被接受，请前往處理',
  },
  template: {
    boundOwner: '綁定跟進人',
    creatingEmptyModule: '創建空白模塊',
    creatingModuleFromTemplate: '從模板中創建',
    addTodo: '添加任務',
    removeTodo: '移除任務',
    selectTemplate: '選擇模板',
    saveTemplate: '添加為模板',
    totalManDayTips: '當前選擇的任務總價值已超過模塊設定的價值',
    dueTips: '未填寫任務的計劃完成日期',
    commentTips: '未填寫搶單任務的備注',
    unBoundOwner: '未綁定任務跟進人',
    moreThanDueTips: '任務的計劃完成日期超過模塊的計劃完成日期',
    projectTips: '報價單的項目與模塊的項目不一致',
    name: '模板名',
    select: '選擇',
    grab: '搶單',
    todo: '任務(模板)',
    grabRange: '搶單範圍',
  },
  grab: {
    isAgreeOwner: '是否同意該用戶接受任務',
    refuseTips: '請填寫拒絕原因',
    isAccept: '是否確定接受該搶單任務',
    contactTips: '請輸入備注信息',
    contactPlaceholder: '備注信息可以是聯係方式或者其他可以聯係的信息',
    canGrabTodos: '當前可搶任務',
    grabList: '搶單列表',
    myRelease: '我的發佈',
    recipientInfo: '接收人信息',
    refuseReason: '拒絕原因',
    empty: '暫無',
  },
};
